import React from 'react';

function CategoriaCabecera({ categoria, contenido, categoriaSeleccionada, setCategoriaSeleccionada, menuAbierto, setDesplegar }) {
  
  const seleccionSubCategoria = () => {
    setCategoriaSeleccionada(categoria); // Selecciona la categoría en el componente padre
    menuAbierto && setDesplegar(true); // Despliega el menú si está cerrado
  };

  return (
    menuAbierto ? 
      <li className='text-base font-bold w-10/12 text-center'>
          <button 
            onClick={seleccionSubCategoria} 
            className={`font-bold w-full text-start my-3 p-2 border-b-2 
                       ${categoriaSeleccionada === categoria ? 'border-b-Verde ' : 'border-b-GrisOscuro'}`}
          >
            <li className={`${categoriaSeleccionada === categoria ? 'text-xl' : 'text-base'}`}>{contenido}</li>
          </button>
      </li>
      :
      <li className='text-bsm xl:text-base font-bold w-10/12 text-center'>
          <button 
            onClick={seleccionSubCategoria} 
            className={`${categoriaSeleccionada === categoria ? 'bg-GrisOscuro text-Blanco' : ''} hover:bg-GrisOscuro hover:text-Blanco w-full h-full text-center`}
          >
            {contenido}
          </button>
      </li>
  );
}

export default CategoriaCabecera;
